import { call, getContext, put, takeEvery } from "redux-saga/effects";

import { CONTEXT } from "@const/redux";
import {
  addStripeFailure,
  addStripeSuccess,
  getStripeCountriesFailure,
  getStripeCountriesSuccess,
} from "./actions";
import {
  addStripeActionType,
  getStripeCountriesActionTypes,
} from "./actionTypes";

const addStripeAsync = ({ StripeService, countryId }) => {
  if (!StripeService) {
    console.log("Required services does not exist");

    return null;
  }

  return StripeService.connectStripe({ countryId });
};

function* addStripe({ payload }) {
  try {
    const { countryId } = payload;
    const { StripeService } = yield getContext(CONTEXT.SERVICES);
    const { data } = yield call(addStripeAsync, {
      StripeService,
      countryId,
    });

    yield put(addStripeSuccess(data));
  } catch ({ error }) {
    yield put(addStripeFailure(error));
  }
}

const getCountriesAsync = ({ StripeService }) => {
  return StripeService.getStripeCountries();
};

function* getCountries() {
  try {
    const { StripeService } = yield getContext(CONTEXT.SERVICES);

    const { data } = yield call(getCountriesAsync, { StripeService });

    yield put(getStripeCountriesSuccess(data));
  } catch ({ error }) {
    console.error(error);
    yield put(getStripeCountriesFailure());
  }
}

export function* watchAddStripe() {
  yield takeEvery(addStripeActionType.request, addStripe);
}

export function* watchGetCountries() {
  yield takeEvery(getStripeCountriesActionTypes.request, getCountries);
}
